<template>
  <section class="login_box" >
    <p class="location_nav"><span class="left">您的位置>首页>忘记密码</span><b class="right">
      <router-link to="/Index">← 返回首页</router-link>
      </b></p>
    <div class="login_form">
      <div class="login_h">
        <b class="left">忘记密码</b>
      </div>
      <div class="login_inp_box">
        <el-input
          class="login_inp auto_h"
          placeholder="账号"
          v-model="account_number">
        </el-input>
        <el-input
          class="login_inp auto_h"
          placeholder="邮箱"
          v-model="mail">
        </el-input>
        <el-button type="primary" class="login_btn"  @click="change_pass_fn">提交请求</el-button>
        <p class="forget_pass txt_right">忘记密码?</p>
      </div>
    </div>
  </section>
</template>

<script>
import { yh_get,yh_post,yh_alert } from "../api/index"
export default {
  data () {
    return {
      height: {
        height: 0
      },
      login_type: "1",
      account_number: "",
      mail: "",
      if_agree: true,
    }
  },
  methods: {
    
    change_pass_fn() {
      if(this.account_number == ""){
        this.$alert('请填写账号', '温馨提示', {
          confirmButtonText: '确定'
        });
        return;
      } 
      if(this.mail == ""){
        this.$alert('请填写邮箱', '温馨提示', {
          confirmButtonText: '确定'
        });
        return;
      }
      var obj = {
        account_number: this.account_number,
        mail: this.mail
      }

      // this.$api.axios_changePass(obj).then(res => {
        this.$alert('新密码已经发送到你的邮箱，请登录邮箱查看！', '温馨提示', {
          center: true,
          confirmButtonText: '知道了'
        });
      // })
    }
  },
  mounted() {
    // if ((document.body) && (document.body.clientHeight))
    // this.height.height = document.documentElement.clientHeight - 140 + "px";
    // console.log(this.height.height)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.login_box{
  /* padding-top: 30px; */
  height: 784px;
  overflow: hidden;
  width: 1000px;
  margin: 0 auto;
}
.location_nav{
  width: 100%;
  height: 20px;
  padding-top: 30px;
  line-height: 20px;
}
.login_form{
  width:530px;
  height:364px;
  background: #ffffff;
  margin: 30px auto 80px;
  padding: 30px 90px;
  box-sizing: border-box
}
.login_h{
  height: 32px;
  line-height: 32px;
  margin-bottom: 42px;
}
.login_h b{
  font-size: 24px;
}
.login_h span{
  color: #999999
}
.login_inp_box{
  width: 350px;

}
.login_inp{
  height: 50px;
  margin-bottom: 20px;
}
.login_btn{
  width: 350px;
  height: 50px;
  margin: 10px auto;
}
a:-webkit-any-link{
  color: #333333;
  text-decoration: none;
}
a.link_qq_login:-webkit-any-link{
  color: #999999;
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/changePass.vue